<template>
  <div class="field-label w-100">
    <div class="col-12 px-0"
    :class="getFormLabelLayout">
      <label
        :for="fieldData.field_name">
          {{ fieldData.label }}<span v-if="fieldData.is_required" class="req">*</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: ['fieldData'],
  methods: {
    // TODO: Needs refactor
    getFormLabelLayout() {
      const formType = this.formdata.field_type;
      const formLayout = formType.split('_')[2];
      let formClassLayout = {};
      if (formLayout === 'right') {
        formClassLayout = {
          'col-md-8': true,
        };
      }
      return formClassLayout;
    },
  },
};
</script>

<style scoped>
label {
  display: inline-block;
  margin-bottom: 0.25rem;
  font-weight: 600;
  max-width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/FieldLabel.vue?1fbf6095